import React, { useContext, useEffect, useState } from 'react';

import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { Button, FloatButton, Table, TableProps, Tag, Card, Space, Typography, Tooltip, Badge, Select } from "antd";
import { ColumnsType } from "antd/es/table";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { BiPencil, BiPlus, BiRefresh } from "react-icons/bi";
import { GetProjecteId } from "../../../../dao/abp/GetProjecteId";
import { GetGrupById } from "../../../../dao/abp/GetProjecteIdGrupId";
import { GetAlumnesValidacioByProject } from "../../../../dao/abp/GetAlumnesValidacioByProject";
import { GetTasquesByprojecteId } from "../../../../dao/abp/GetTasquesByProjecteId";
import { GetAlumnesTasquesByProject } from "../../../../dao/abp/GetAlumnesTasquesByProject";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import TascaModal from "../TascaModal";
import { GetProjecteIdConfiguracio } from "../../../../dao/abp/GetProjecteIdConfiguracio";
import { red } from "@ant-design/colors";
import { PostOrdreTasca } from "../../../../dao/abp/PostOrdreTasca";
import { CiImport } from "react-icons/ci";
import { IoOptions } from "react-icons/io5";
import CopiarProjecteModal from "../CopiarProjecteModal";
import { GetUsuarisIdProjectes } from "../../../../dao/GetUsuarisIdProjectes";
import { GetSprintsByProject } from "../../../../dao/abp/GetSprintsByProject";
import SprintConfigModal from "../SprintConfigModal";

interface Props {
    sprint: any;
}

const ProjecteIdGestorTasques = (props: Props) => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_grup, id_projecte, id_usuari } = useParams();

    const navigate = useNavigate();
    const [modules, setModules] = useState<any[]>([]);
    const [projectes, setProjectes] = useState<any[]>([]);
    const [data, setData] = useState<any>();
    const [modal, setModal] = useState(false);
    const [modalImport, setModalImport] = useState(false);
    const [selected, setSelected] = useState<any>();

    const [projecte, setProjecte] = useState<any>();
    const [valdacio, setValidacio] = useState<any[]>([]);

    const [grup, setGrup] = useState<any>();

    const [loading, setLoading] = useState(false);

    // Sprint management state
    const [sprints, setSprints] = useState<any[]>([]);
    const [sprintModalVisible, setSprintModalVisible] = useState(false);
    const [selectedSprintFilter, setSelectedSprintFilter] = useState<number>(0);


    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
            loadSprints();
        }
    }, [isLoggedIn]);

    async function loadSprints() {
        if (id_projecte) {
            const data = await GetSprintsByProject(id_projecte + "");
            setSprints(data || []);
        }
    }

    async function checkDades() {
        setLoading(true);
        await checkProjecte(id_projecte);
        await checkTasques();
        await checkValidacio();
        setLoading(false);
    }

    async function checkProjecte(id: any) {
        setLoading(true);
        const data = await GetProjecteId(id_projecte + "", 0);

        if (user.tipus === "0") {
            setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'avaluacio', nav: '/abp' },
            { nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` }], true);

        } else {
            setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'avaluacio', nav: '/abp' },
            { nom: 'projectes', nav: '/abp/projectes' },
            { nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` },
            { nom: 'tasques', nav: `/abp/projectes/${data.id}/grups/${id_grup}` }], true);
        }

        setProjecte(data);
        setLoading(false);
    }

    async function checkUsuari() {
        setLoading(true);
        setGrup(await GetGrupById(id_grup + ""));
        await setLoading(false);
    }

    async function checkValidacio() {
        setLoading(true);
        const val = await GetAlumnesValidacioByProject(userId + "", id_projecte + "");
        setValidacio(val);
        await setLoading(false);
    }


    function onClose(value: boolean) {
        setModal(false);
        setLoading(false);
        if (value)
            checkTasques();
    }


    const colors = [
        AvaluacioColors.colors.color1,
        AvaluacioColors.colors.color2,
        AvaluacioColors.colors.color3,
        AvaluacioColors.colors.color4,
        AvaluacioColors.colors.color5,
        AvaluacioColors.colors.color6
    ];

    async function checkTasques() {
        setLoading(true);
        if ((user.tipus === "1" || user.tipus === "0"))
            setModules(await GetTasquesByprojecteId(id_projecte ? id_projecte : "0"));
        else
            setModules(await GetAlumnesTasquesByProject(id_grup + "",
                id_projecte ? id_projecte : "0", 0));
        setLoading(false);
    }

    async function changeOrdre(ele: any, ordre: number) {
        setLoading(true);
        await PostOrdreTasca(id_projecte + "", ele.id, (ele.ordre + ordre));
        //console.log(ele.ordre + ordre);
        await checkDades();
        setLoading(false);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'actions',
            dataIndex: 'actions',
            width: 60,
            render: (e, ele) => (
                <Space direction="vertical" size={2}>
                    {ele.ordre > 1 && (
                        <Tooltip title="Pujar ordre">
                            <Button
                                type="text"
                                size="small"
                                onClick={() => changeOrdre(ele, -1)}
                                icon={<BsArrowUp style={{ color: AvaluacioColors.colors.color5 }} />}
                            />
                        </Tooltip>
                    )}
                    {ele.ordre < modules?.length && (
                        <Tooltip title="Baixar ordre">
                            <Button
                                type="text"
                                size="small"
                                onClick={() => changeOrdre(ele, 1)}
                                icon={<BsArrowDown style={{ color: AvaluacioColors.colors.color4 }} />}
                            />
                        </Tooltip>
                    )}
                </Space>
            )
        },
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id',
            width: 80,
            render: (text, ele) => (
                <div style={{ paddingLeft: ele.depth ? `${ele.depth * 30}px` : '10px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {ele.depth > 0 && <Typography.Text type="secondary" style={{ fontSize: 16 }}>↳</Typography.Text>}
                    <Typography.Text type="secondary" strong={ele.depth === 0}>#{text}</Typography.Text>
                </div>
            )
        },
        {
            title: 'Sprint',
            key: 'sprint',
            dataIndex: 'sprint',
            width: 80,
            render: (e) => {
                const sprintInfo = sprints.find(s => Number(s.numero) === Number(e));
                return (
                    <Tooltip title={sprintInfo?.titol || `Sprint ${e}`}>
                        <Badge count={e} style={{ backgroundColor: colors[e % 6], cursor: 'help' }} />
                    </Tooltip>
                );
            }
        },
        {
            title: 'Aula / Mòdul',
            key: 'modul',
            dataIndex: 'modul',
            width: 150,
            render: (e, ele) => (
                <Tag color={colors[ele.id_aula % 6]} style={{ borderRadius: 12 }}>
                    {e?.length > 15 ? `${e.substring(0, 15)}...` : e}
                </Tag>
            )
        },
        {
            title: 'Resultat d\'Aprenentatge',
            key: 'ranom',
            dataIndex: 'ranom',
            width: 200,
            render: (e, ele) => (
                <Space direction="vertical" size={0}>
                    <Space>
                        <Tag color={colors[ele.ra % 6]} style={{ fontWeight: 'bold', marginBottom: 4 }}>
                            {ele.ranum}
                        </Tag>
                        {ele.depth > 0 && <Tag color="purple" style={{ marginBottom: 4 }}>Subtasca</Tag>}
                    </Space>
                    <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                        {e?.length > 40 ? `${e.substring(0, 40)}...` : e}
                    </Typography.Text>
                </Space>
            )
        },
        {
            title: 'Descripció',
            key: 'descripcio',
            dataIndex: 'descripcio',
            width: 400,
            render: (text: string) => (
                <Typography.Paragraph
                    ellipsis={{ rows: 2, expandable: true, symbol: 'more' }}
                    style={{ margin: 0, color: '#595959' }}
                >
                    {text}
                </Typography.Paragraph>
            )
        },
        {
            title: 'Pes',
            key: 'pes',
            dataIndex: 'pes',
            width: 80,
            render: (e) => (
                <Typography.Text strong style={{ color: '#1f1f1f' }}>
                    {e}%
                </Typography.Text>
            )
        },
        {
            title: 'Accions',
            key: 'actions',
            dataIndex: 'actions',
            width: 80,
            fixed: 'right',
            render: (e, ele) => (
                <Space>
                    <Tooltip title="Afegir Subtasca">
                        <Button
                            type="default"
                            shape="circle"
                            onClick={() => addSubtask(ele)}
                            icon={<BiPlus style={{ color: AvaluacioColors.colors.color4 }} />}
                            style={{ border: 'none', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                        />
                    </Tooltip>
                    <Tooltip title="Editar Tasca">
                        <Button
                            type="default"
                            shape="circle"
                            onClick={() => edit(ele)}
                            icon={<BiPencil style={{ color: AvaluacioColors.colors.color6 }} />}
                            style={{ border: 'none', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const buildTree = (tasks: any[]) => {
        if (!tasks) return [];
        const taskMap: Record<number, any> = {};
        const roots: any[] = [];

        tasks.forEach(t => {
            taskMap[t.id] = { ...t, children: [] };
        });

        tasks.forEach(t => {
            if (t.id_tarea_padre) {
                if (taskMap[t.id_tarea_padre]) {
                    taskMap[t.id_tarea_padre].children.push(taskMap[t.id]);
                } else {
                    roots.push(taskMap[t.id]);
                }
            } else {
                roots.push(taskMap[t.id]);
            }
        });

        const sortAndFlatten = (node: any, depth: number, result: any[]) => {
            const { children, ...nodeWithoutChildren } = node;
            nodeWithoutChildren.depth = depth;
            result.push(nodeWithoutChildren);

            if (children && children.length > 0) {
                children.sort((a: any, b: any) => a.ordre - b.ordre);
                children.forEach((child: any) => sortAndFlatten(child, depth + 1, result));
            }
        };

        roots.sort((a: any, b: any) => a.ordre - b.ordre);

        const flatList: any[] = [];
        roots.forEach(root => sortAndFlatten(root, 0, flatList));

        return flatList;
    };


    const calculateFinalGrade = () => {
        return modules.reduce((total, item) => {
            return (total + item.pes) || 0;
        }, 0).toFixed(2);
    };

    const tableProps: TableProps<any> = {
        loading
    };

    async function checkPreviosData() {
        setData((await GetProjecteIdConfiguracio(id_projecte + ""))?.projecte_tree);
    }

    function nuevo() {
        setLoading(true);
        checkPreviosData();

        setSelected({});
        setModal(true);
    }

    function edit(ele: any) {
        setLoading(true);
        checkPreviosData();

        setSelected(ele);
        setModal(true);
    }

    function addSubtask(ele: any) {
        setLoading(true);
        checkPreviosData();

        setSelected({ id_tarea_padre: ele.id });
        setModal(true);
    }

    async function importFromProjecte() {
        setLoading(true);
        setProjectes(await GetUsuarisIdProjectes(userId));
        setModalImport(true);
    }

    async function closeModalImport() {
        setModalImport(false);
        await checkDades();
    }

    return (
        <div style={{ padding: '24px', maxWidth: 1600, margin: '0 auto' }}>
            <br />
            {/* Header Section */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 24,
                background: '#fff',
                padding: '16px 24px',
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{
                        backgroundColor: AvaluacioColors.colors.color1,
                        padding: 10,
                        borderRadius: 10,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <IoOptions size={24} />
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: 24, fontWeight: 600, color: '#1f1f1f' }}>Gestió de Tasques</h2>
                        <span style={{ color: '#8c8c8c' }}>Administració de les tasques del projecte</span>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: 12 }}>
                    {(user.tipus === "1" || user.tipus === "0") && !loading && (
                        <>
                            <Button
                                icon={<BiRefresh size={18} />}
                                onClick={() => checkDades()}
                                size="large"
                            >
                                Actualitzar
                            </Button>
                            <Button
                                icon={<CiImport size={18} />}
                                onClick={() => importFromProjecte()}
                                size="large"
                                style={{ backgroundColor: AvaluacioColors.colors.color4, color: 'white', border: 'none' }}
                            >
                                Importar
                            </Button>
                            <Button
                                icon={<IoOptions size={18} />}
                                onClick={() => setSprintModalVisible(true)}
                                size="large"
                                style={{ backgroundColor: AvaluacioColors.colors.color3, color: 'white', border: 'none' }}
                            >
                                Gestionar Sprints
                            </Button>
                            <Button
                                type="primary"
                                icon={<BiPlus size={18} />}
                                onClick={() => nuevo()}
                                size="large"
                                style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                            >
                                Nova Tasca
                            </Button>
                        </>
                    )}
                </div>
            </div>

            {/* Main Content */}
            <Card
                bordered={false}
                style={{ borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
                bodyStyle={{ padding: '16px' }}
            >
                {/* Sprint Filter */}
                <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Typography.Text strong>Filtrar per Sprint:</Typography.Text>
                    <Select
                        style={{ width: 250 }}
                        value={selectedSprintFilter}
                        onChange={(value) => setSelectedSprintFilter(value)}
                        options={[
                            { value: 0, label: 'Tots els sprints' },
                            ...sprints.map(s => ({
                                value: s.numero,
                                label: `${s.titol}${s.data_inici && s.data_final ? ` (${new Date(s.data_inici).toLocaleDateString()} - ${new Date(s.data_final).toLocaleDateString()})` : ''}`
                            }))
                        ]}
                    />
                </div>

                <Table
                    size="middle"
                    {...tableProps}
                    columns={columns}
                    rowKey="id"
                    dataSource={buildTree(modules ? modules.filter(m => selectedSprintFilter === 0 || Number(m.sprint) === Number(selectedSprintFilter)) : [])}
                    pagination={false}
                    bordered={false}
                    onRow={(record) => {
                        const isSubtask = record.depth > 0;
                        return {
                            style: {
                                backgroundColor: isSubtask ? '#f5f7fa' : '#ffffff',
                                borderLeft: isSubtask ? `6px solid #babbbd` : '6px solid transparent',
                            }
                        };
                    }}
                    summary={() => (
                        <Table.Summary.Row style={{ backgroundColor: '#fafafa' }}>
                            <Table.Summary.Cell colSpan={6} align="right" index={0}>
                                <strong style={{ fontSize: '1.1em' }}>Suma total de pesos:</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={2}>
                                {(() => {
                                    const grade = calculateFinalGrade();
                                    return (
                                        <Tag style={{ fontSize: '1.1em', padding: '4px 8px' }} color={grade == "100.00" ? AvaluacioColors.colors.color5 : red[3]}>
                                            {grade}%
                                        </Tag>
                                    );
                                })()}
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    )}
                />
            </Card>

            {modal && <TascaModal data={data} element={selected} visible={modal} onClose={onClose}
                id_projecte={id_projecte + ""} tasks={modules} />}
            {modalImport && <CopiarProjecteModal data={projectes} element={selected} visible={modalImport}
                onClose={closeModalImport} id_projecte={id_projecte + ""} />}
            {sprintModalVisible && (
                <SprintConfigModal
                    visible={sprintModalVisible}
                    onClose={() => {
                        setSprintModalVisible(false);
                        loadSprints();
                        checkDades();
                    }}
                    idProjecte={id_projecte + ""}
                />
            )}
        </div>
    );
};

export default ProjecteIdGestorTasques;
